import { User } from '@myapp/contract'
import { EntitySearchSelect } from '../../../shared/ui/search/EntitySearchSelect/EntitySearchSelect'
import { useUsersInfiniteQuery } from '../api/queries/useUsersInfiniteQuery'
import { useUserDetail } from '../api/queries/useUserDetail'

interface HandwerkerItem {
  id: number
  name: string
  email: string
}

interface HandwerkerSearchSelectProps {
  value: number | null | undefined
  onChange: (id: number | null) => void
  onLabelChange?: (label: string | null) => void
  disabled?: boolean
  readOnly?: boolean
  hasError?: boolean
  className?: string
  placeholder?: string
}

function adaptUser(u: User): HandwerkerItem {
  return { id: Number(u.id), name: u.name, email: u.email }
}

const WORKER_PARAMS = { role: 'WORKER' as const }

export function HandwerkerSearchSelect({
  value,
  onChange,
  onLabelChange,
  disabled,
  readOnly,
  hasError,
  className,
  placeholder = 'Handwerker suchen…',
}: HandwerkerSearchSelectProps) {
  const useAdaptedInfiniteHook = (params: any, options?: { enabled?: boolean }) => {
    const result = useUsersInfiniteQuery({ ...params, ...WORKER_PARAMS }, options)
    return {
      ...result,
      data: result.data
        ? { ...result.data, items: result.data.items.map(adaptUser) }
        : result.data,
    }
  }

  const useAdaptedDetailHook = (id: number | undefined, options?: { enabled?: boolean }) => {
    const result = useUserDetail(id != null ? String(id) : undefined, options)
    return {
      ...result,
      data: result.data ? adaptUser(result.data) : undefined,
    }
  }

  return (
    <EntitySearchSelect<HandwerkerItem>
      value={value}
      onChange={(id, item) => {
        onChange(id)
        onLabelChange?.(item ? item.name : null)
      }}
      useInfiniteHook={useAdaptedInfiniteHook}
      useDetailHook={useAdaptedDetailHook}
      searchParamName="search"
      getLabel={(h) => h.name}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      hasError={hasError}
      className={className}
    />
  )
}
